import { JSX } from 'preact'
import classnames from 'classnames'
import { BlockType, TBlockProps } from '@gsc/types'
import { useComponentStyle } from '../Style'
import { Checkbox } from './Checkbox'

export function CheckboxGroup({
  name,
  required,
  options = [],
  ...props
}: TBlockProps<BlockType.CheckboxGroup>): JSX.Element {
  const { classes } = useComponentStyle('input-check', props)
  return (
    <div className={classnames(classes)}>
      {options.map(opt => (
        <Checkbox {...opt} name={name} required={required} />
      ))}
    </div>
  )
}
